import EventHero from '../../../screens/customer/events/EventHero';
import EventGallery from '../../../screens/customer/events/EventGallery';
import Category from '../../../screens/customer/events/Category';
import VedioSection from '../../customer/home/VedioSection';
import MyNavbar from '../../../components/customer/MyNavbar';
import Footer from '../../../components/customer/Footer';

const Event = () => {
  return (
    <>
      <EventHero />
      <EventGallery />
      <Category />
      <VedioSection />
      <MyNavbar />
      <Footer />
      
    </>
  );
};

export default Event;
